<template>
  <div id="app">
    <b-navbar fixed-top shadow spaced type="is-info">
      <template #brand>
        <b-navbar-item :to="{ path: '/mainscreen' }" tag="router-link">
          <img
              alt="Geogaming Logo"
              src="img/menu/logo/geogaming-bar-world.png"
          >
        </b-navbar-item>
      </template>
      <template #start>
        <b-navbar-item :to="{ path: '/maps' }" tag="router-link">
          Maps
        </b-navbar-item>
        <b-navbar-item :to="{ path: '/packs' }" tag="router-link">
          Packs
        </b-navbar-item>
        <b-navbar-item :to="{ path: '/rawActivities' }" tag="router-link">
          Activities
        </b-navbar-item>
        <b-navbar-item :to="{ path: '/introTexts' }" tag="router-link">
          Intros
        </b-navbar-item>
        <b-navbar-item :to="{ path: '/games' }" tag="router-link">
          Games
        </b-navbar-item>
        <b-navbar-item :to="{ path: '/calendar' }" tag="router-link">
          Calendar
        </b-navbar-item>
        <b-navbar-item :to="{ path: '/billing' }" tag="router-link">
          Billing
        </b-navbar-item>
        <b-navbar-item :to="{ path: '/help' }" tag="router-link">
          Help
        </b-navbar-item>
        <b-navbar-dropdown v-if="apiKey && apiKey.includes('superadmin')" arrowless hoverable label="Admin">
          <b-navbar-item :to="{ path: '/admin' }" tag="router-link">
            <b-icon icon="chevron-right"></b-icon>&nbsp;Administration
          </b-navbar-item>
          <b-navbar-item :to="{ path: '/specialfeatures' }" tag="router-link">
            <b-icon icon="chevron-right"></b-icon>&nbsp;Special features
          </b-navbar-item>
        </b-navbar-dropdown>

      </template>

      <template #end>
        <b-navbar-item tag="div">
          <div class="buttons">
            <a v-if="apiKey && apiKey.includes('superadmin')" class="button is-primary"
               @click="go('ChangeTenant')">
              <strong>Tenant: {{ tenantId }}</strong>
            </a>
            <a class="button is-light" @click="logout()">
              Log out
            </a>
          </div>
        </b-navbar-item>
      </template>

    </b-navbar>

    <section class="section">
      <div class="container is-vcentered">
        <router-view/>
      </div>
    </section>

    <footer class="footer">
      <div class="content has-text-centered">
        <div class="imagecontainer" style="margin-bottom: 10px">
          <img :src="siteLogo" align="center">
        </div>
        <p>
          {{ new Date().getFullYear() }}&nbsp;—&nbsp;<strong>Geogaming</strong>
          <span
              v-if="siteTitle && !siteTitle.toLocaleLowerCase().includes('geogaming')"> for&nbsp;<strong>{{
              siteTitle
            }}</strong></span>
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
import selected from './geogaming-selected'
import config from './geogaming-config'
import _ from 'lodash'
import {metro} from './main'

const DEFAULT_CONFIG_NAME = 'default'
const configName = selected.envName
console.log(' > stage:' + configName)

const DEFAULT_TITLE = config[configName] ? config[configName].title : config[DEFAULT_CONFIG_NAME].title
const DEFAULT_IMAGE_URL = config[configName] ? config[configName].logo : config[DEFAULT_CONFIG_NAME].logo

export default {
  name: 'app',
  data() {
    return {
      siteTitle: '',
      siteLogo: '',
      expertMode: '',
      apiKey: '',
      tenantId: '',
    }
  },
  created() {
    metro.$on('api_key_updated', this.updateApiKey)
  },
  mounted() {
    this.siteTitle = _.get(this.$store.state, 'tenant.provider', DEFAULT_TITLE)
    this.expertMode = _.get(this.$store.state, 'tenant.expertMode', false)
    this.siteLogo = _.get(this.$store.state, 'tenant.logoUrl', DEFAULT_IMAGE_URL)
    this.updateApiKey(_.get(this.$store.state, 'apiKey', null))
  },
  methods: {
    updateApiKey(apiKey) {
      this.apiKey = apiKey
      if (this.apiKey) {
        this.tenantId = this.apiKey.split('_')[0]
      }
    },
    logout() {
      this.$store.commit('SET_IS_LOGGED_IN', false)
      this.$store.commit('SET_LOGIN', null)
      this.$store.commit('SET_API_KEY', null)
      metro.$emit('api_key_updated', null)
      this.$store.commit('SET_CONFIG', null)
      this.$store.commit('SET_TENANT', null)
      this.$router.push({name: 'LoginForm'})
    },
    go(target) {
      this.$router.push({name: target})
    },
  }
}
</script>

<style>
/* Not necessary as buefy.css is imported in main.js */
/*@import "../node_modules/bulma/css/bulma.css";*/
/* Syntax highlithing for code snippets in Markdown */
@import "../node_modules/highlightjs/styles/github-gist.css";

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.active {
  font-weight: bold;
  font-size: 1.5em;
  display: block;
  outline: none;
}

.imagecontainer {
  height: 88px;
  alignment: center;
}

.imagecontainer img {
  max-height: 100%;
  max-width: 100%;
}
</style>

<style lang="scss">


// Import Bulma's core
@import "~bulma/sass/utilities/_all";

@import url("https://fonts.googleapis.com/css?family=Lato");

$family-primary: "Lato";
$family-sans-serif: "Lato, sans-serif";

// Set your colors
$primary: #1d4472; // blue
$primary-invert: findColorInvert($primary);
$secondary: #73b895; // green
$secondary-invert: findColorInvert($secondary);
$accent: #e1874e; // orange
$accent-invert: findColorInvert($accent);
$danger: #c55558; // red
$danger-invert: findColorInvert($danger);
$warning: #efc866; // yellow
$warning-invert: findColorInvert($warning);
$info: #67a3e8; // blue clair
$info-invert: findColorInvert($info);
$success: #74b996; // green
$success-invert: findColorInvert($success);
$bleugris: #e8eff4; // bleugris
$bleugris-invert: findColorInvert($bleugris);
$gris: #eaeaea; // gwi
$gris-invert: findColorInvert($gris);

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
    "white": ($white, $black),
    "black": ($black, $white),
    "light": ($light, $light-invert),
    "dark": ($dark, $dark-invert),
    "primary": ($primary, $primary-invert),
    "info": ($info, $info-invert),
    "success": ($success, $success-invert),
    "warning": ($warning, $warning-invert),
    "danger": ($danger, $danger-invert),
    "accent": ($accent, $accent-invert)
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

@import '~bulma';
@import '~buefy/src/scss/buefy';
</style>
